import Typography from 'src/components/design-system/Typography'

export default function DownloadFile({
  href,
  title,
  meta,
  downloadLabel,
  DownloadIcon,
  FileIcon,
  className = '',
  color = 'default',
  openInBrowser = false,
}) {
  if (!href) return null
  const isJournalDomain = color === 'journalDomain'

  return (
    <div
      className={`flex flex-col gap-16 max-t:pb-24 max-t:border-b ${
        isJournalDomain ? 'border-b-basic-gray7' : 'border-b-dark-blue-dark-blue4'
      } ${className}`.trim()}
    >
      <div className="flex flex-col gap-16">
        <div className="flex items-end gap-8">
          {FileIcon ? (
            <FileIcon aria-hidden="true" className={isJournalDomain ? '[&_path]:stroke-basic-black' : ''} />
          ) : (
            <span />
          )}
          {meta && (
            <Typography variant="body4" color={isJournalDomain ? 'text-basic-black' : 'text-dark-blue-dark-blue2'}>
              {meta}
            </Typography>
          )}
        </div>
        {title && <Typography variant="h3-light">{title}</Typography>}
      </div>

      <a
        href={href}
        download={openInBrowser ? undefined : true}
        target="_blank"
        rel="noreferrer"
        className={`mt-auto inline-flex items-center gap-8 buttons-l buttons--bold focus-visible:outline-offset-4 focus-visible:outline-functional-focus-color ${
          isJournalDomain
            ? 'text-basic-black supports-hover:hover:text-basic-black'
            : 'text-dark-blue-dark-blue2 supports-hover:hover:text-dark-blue-dark-blue1'
        }`}
        aria-label={`${downloadLabel} ${title}`}
      >
        {downloadLabel}
        {DownloadIcon ? (
          <DownloadIcon aria-hidden="true" className={isJournalDomain ? '[&_path]:stroke-basic-black' : ''} />
        ) : null}
      </a>
    </div>
  )
}
